var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEstimate = function SvgEstimate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.274,
    height: 39.061,
    viewBox: "0 0 42.274 39.061"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "133.1%",
    height: "198.4%",
    x: "-16.6%",
    y: "-35.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0785893794 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M5.21 0h31.854l5.21 14.23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.767 12.78h33.81v24.28a2 2 0 0 1-2 2H5.768a2 2 0 0 1-2-2V12.78z",
    opacity: 0.461
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.815 34.047h-1.793v-1.91c-2.442-.34-3.602-2.142-3.76-3.659l2.179-.535c.105 1.124.843 2.16 2.46 2.16 1.142 0 1.81-.554 1.81-1.34 0-.606-.44-1.07-1.318-1.266l-1.617-.357c-1.897-.429-3.074-1.642-3.074-3.356 0-1.892 1.44-3.284 3.32-3.587v-1.91h1.793v1.964c2.02.374 2.899 1.802 3.145 2.998l-2.162.625c-.105-.625-.562-1.66-2.003-1.66-1.124 0-1.739.66-1.739 1.392 0 .553.387 1.017 1.212 1.196l1.6.374c2.213.5 3.215 1.839 3.215 3.445 0 1.642-1.16 3.159-3.268 3.498v1.928z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#FEEAE8"
  }))));
};
export default SvgEstimate;